module.exports = __webpack_public_path__ + "img/j1.67f1e11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slideShow/j1.jpg
// module id = CnRu
// module chunks = 1